import { Status1 } from '../types';

/**
 * Custom event for updating a cell's status
 */
type StatusUpdateEvent = CustomEvent<{
  statusCode: Status1['statusCode'];
}>;

/**
 * Custom event for opening a cell's tooltip
 */
type TooltipOpenEvent = CustomEvent<void>;

/**
 * Type-safe event handlers for StatusCell
 */
interface StatusCellEventMap {
  updateStatus: StatusUpdateEvent;
  openTooltip: TooltipOpenEvent;
}

/**
 * Creates a type-safe custom event for StatusCell components
 */
export function createStatusCellEvent<K extends keyof StatusCellEventMap>(
  type: K,
  detail: StatusCellEventMap[K]['detail'],
): StatusCellEventMap[K] {
  return new CustomEvent(type, { detail }) as StatusCellEventMap[K];
}